import './App.css';

import { Link, Routes, Route } from "react-router-dom";

import RetirementAgeCalc from './routes/retirement-age-calc';
import RMDCalc from './routes/rmd-calc';
import ChildTaxCreditCalc from './routes/child-tax-credit-calc';
import UmbrellaCalc from './routes/umbrella-insurance-calc';
import SecondStimulusCheckCalc from './routes/second-stimulus-check-calc';
import StimulusCheckCalc from './routes/third-stimulus-check-calc';
import NetWorthCalc from 'routes/net-worth-calc';
import RetirementSavingsCalc from 'routes/retirement-savings-calc';
import TaxBurdenCalc from 'routes/tax-burden-calc';
import BudgetWorksheet from 'routes/budget-worksheet';
import TickerTool from 'routes/ticker';
import MapTool from 'routes/map';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route index path="/" element={<AppNav />} />
        <Route path="retirement-age-calc" element={<RetirementAgeCalc />} />
        <Route path="rmd-calc" element={<RMDCalc />} />
        <Route path="child-tax-credit-calc" element={<ChildTaxCreditCalc />} />
        <Route path="umbrella-insurance-calc" element={<UmbrellaCalc />} />
        <Route path="second-stimulus-check-calc" element={<SecondStimulusCheckCalc />} />
        <Route path="third-stimulus-check-calc" element={<StimulusCheckCalc />} />
        <Route path="net-worth-calc" element={<NetWorthCalc />} />
        <Route path="retirement-savings-calc" element={<RetirementSavingsCalc />} />
        <Route path="tax-burden-calc" element={<TaxBurdenCalc />} />
        <Route path="budget-worksheet" element={<BudgetWorksheet />} />
        <Route path="ticker" element={ <TickerTool /> } />
        <Route path="map" element={ <MapTool /> } />
      </Routes>
    </div>
  );
}

function AppNav() {
  return (
    <div>
      <h1>Kiplinger Calculators</h1>

      <hr />
      <br/>

      <nav>
        <Link to="retirement-age-calc">Retirement Age Calculator</Link>
        <br/>
        <br/>
        <Link to="rmd-calc">Required Minimum Distribution Calculator</Link>
        <br/>
        <br/>
        <Link to="retirement-savings-calc">Retirement Savings Calculator</Link>
        <br/>
        <br/>
        <br/>
        <Link to="child-tax-credit-calc">Child Tax Credit Calculator</Link>
        <br/>
        <br/>
        <Link to="second-stimulus-check-calc">Second Stimulus Check Calculator</Link>
        <br/>
        <br/>
        <Link to="third-stimulus-check-calc">Third Stimulus Check Calculator</Link>
        <br/>
        <br/>
        <Link to="tax-burden-calc">Your Tax Burden Calculator</Link>
        <br/>
        <br/>
        <br/>
        <Link to="net-worth-calc">Net Worth Calculator</Link>
        <br/>
        <br/>
        <br/>
        <Link to="umbrella-insurance-calc">Umbrella Insurance Calculator</Link>
        <br/>
        <br/>
        <br/>
        <Link to="budget-worksheet">Household Budget Worksheet</Link>
        <br/>
        <br/>
        <Link to="ticker">Ticker</Link>
        <br/>
        <Link to="ticker?ticker=BBT-PF">Ticker with query params</Link>
        <br/>
        <br/>
        <Link to="map">Tax Map for Middle-Class Families</Link>
        <br/>
        <Link to="map?maptype=retirees">Tax Map for Retirees</Link>
      </nav>
    </div>
  );
}

export default App;
